import { Box, Button, DialogContent, Menu, MenuItem, Skeleton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import { KeyboardArrowDown, Logout, Settings } from "@mui/icons-material";
import useRedirect from "../../helper/direct";
import useAuthGlobal from "../../context/useAuthGlobal";
import { clearAuthSession } from "src/utils/authSession";
import EditIcon from "./icon/EditIcon";
import appConfig from "src/config/env";
import { userRoleType } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import ListCategories from "./ListCategories";
import useMeUpdate from "src/hooks/user/useMeUpdate";
import { enqueueSnackbar } from "notistack";
import useWarehouseStore from "src/stores/useWarehouseStore";
import useWareHouseList from "src/hooks/warehouse/useWareHouseList";

const SetUpCurrentWarehouse = ({ userMe }) => {
  const { closeDialog } = useAppGlobal();
  const [searchValue, setSearchValue] = useState(userMe?.currentWarehouse?._id);
  const [selectedWarehouse, setSelectedWarehouse] = useState(userMe?.currentWarehouse ?? null);
  const [warehouseQuery, setWarehouseQuery] = useState({ skip: 0, limit: 20 });
  const { data: warehouseList } = useWareHouseList(warehouseQuery);
  const { setCurrentWarehouse } = useWarehouseStore();

  const { trigger: update } = useMeUpdate();

  const onUpdate = async () => {
    const res = await update({
      body: {
        currentWarehouse: searchValue,
      },
    });
    if (res?.success) {
      setCurrentWarehouse({ currentWarehouse: searchValue, isUpdated: false });
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  return (
    <DialogContent>
      <Stack
        py={2}
        gap={2}
      >
        <Typography>
          <strong>Kho hiện tại: </strong>
          {userMe?.currentWarehouse?.name ?? "N/a"}
        </Typography>
        <ListCategories
          value={selectedWarehouse}
          onChange={(warehouse) => {
            setSelectedWarehouse(warehouse);
            setSearchValue(warehouse?._id);
          }}
          warehouse={warehouseList?.data ?? []}
          setSelectedWarehouse={setWarehouseQuery}
          hasMore={warehouseList?.data?.length >= 20}
        />
        <Typography
          variant="caption"
          fontStyle="italic"
          fontWeight="light"
        >
          Việc thiết lập quyền tác vụ giúp cho hệ thống xác định admin đang thao tác các tác vụ dưới danh nghĩa kho nào (Xuất kho, Nhập kho,..). Các phân quyền chức năng vẫn theo
          phân quyền vai trò super admin.
        </Typography>
        <Button
          onClick={onUpdate}
          variant="contained"
        >
          Cập nhật
        </Button>
      </Stack>
    </DialogContent>
  );
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow: "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function UserMeComp() {
  const { handleOpenDialog } = useAppGlobal();
  const { userMe, setUserMe } = useAuthGlobal();
  const redirect = useRedirect();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    clearAuthSession(setUserMe);
    redirect("/");
    handleClose();
  };

  const handleUserEdit = () => {
    redirect("/user-profile");
  };

  const handleSetUpTaskPermission = () => {
    handleOpenDialog({
      title: "Thiết lập quyền tác vụ",
      size: "sm",
      content: <SetUpCurrentWarehouse userMe={userMe} />,
    });
  };

  return (
    <>
      {!!userMe ? (
        <>
          <Button
            fullWidth
            id="demo-customized-button"
            aria-controls={open ? "demo-customized-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            disableElevation
            onClick={handleClick}
            endIcon={<KeyboardArrowDown />}
            sx={{
              display: "flex",
              gap: "12px",
              justifyContent: "space-between",
              // maxWidth: "215px !important",
              width: "auto",
            }}
          >
            <Box
              sx={{
                width: { xs: "28px", md: "44px" },
                height: { xs: "28px", md: "44px" },
                borderRadius: "100px",
                overflow: "hidden",
                minWidth: { xs: "28px", md: "44px" },
              }}
            >
              <img
                style={{ width: "100%", objectFit: "cover", height: "100%" }}
                src={appConfig.API_FILE + `/${userMe?.avatar?.src}`}
                alt=""
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              textAlign="left"
              sx={{ "@media (max-width: 600px)": { display: "none" } }}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                noWrap
                width="fit-content"
              >
                {userMe?.fullName ?? "-"}
              </Typography>
              <Typography variant="body2">{userMe?.currentWarehouse?.name ?? "-"}</Typography>
            </Box>
          </Button>
          <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem sx={{ display: { xs: "block", sm: "none" } }}>
              <Typography
                variant="body1"
                fontWeight="bold"
              >
                {userMe?.fullName ?? "-"}
              </Typography>
              <Typography variant="body2">{userMe?.currentWarehouse?.name ?? "-"}</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleUserEdit}
              disableRipple
            >
              <EditIcon />
              <Typography
                ml="12px"
                variant="body2"
              >
                Cập nhật hồ sơ
              </Typography>
            </MenuItem>
            {userMe?.role?.code === userRoleType.superAdmin.toLowerCase() && (
              <MenuItem
                onClick={handleSetUpTaskPermission}
                disableRipple
              >
                <Settings />
                <Typography variant="body2">Thiết lập quyền tác vụ</Typography>
              </MenuItem>
            )}

            <MenuItem
              onClick={handleLogOut}
              disableRipple
            >
              <Logout />
              <Typography variant="body2">Log out</Typography>
            </MenuItem>
          </StyledMenu>
        </>
      ) : (
        <Skeleton
          width={"100%"}
          height={"44px"}
        />
      )}
    </>
  );
}
